import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import VoiceFlow from 'components/Flows/VoiceFlows/VoiceFlows';
import VoiceAnalysisDrawer from 'components/Analyses/VoiceAnalyses/Drawer/Drawer';

const VoiceFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <VoiceAnalysisDrawer />
      <VoiceFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <VoiceFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);